.ux-iws-event-calendar-sheet {
    flex: 0 0 auto;
    width: 100%;
    max-width: 600px;
    font-family: var(--ux-font);
    font-weight: 300;

    &__header,
    &__calendar,
    &__days,
    &__day-names {
        display: flex;
        flex-flow: row wrap;
        align-items: center;
        justify-content: center;
        width: 100%;
    }

    &__header {
        flex-flow: row nowrap;
    }

    &__header button {
        appearance: none;
        background: transparent none;
        border: 0 none transparent;
        box-sizing: border-box;
        display: flex;
        flex: 0 0 auto;
        padding: 0;
        margin: 0;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        width: 44px;
        height: 44px;
    }

    &__title {
        flex: 1 1 auto;
        text-align: center;

        .ux-label {
            padding: 0;
        }
    }

    &__day-names {
        font-size: 12px;

        .ux-iws-event-calendar-sheet__day__label {
            background-color: transparent;
        }
    }

    &__days {
        flex-flow: row wrap;
        align-items: flex-start;
        justify-content: flex-start;
    }

    &__day {
        flex: 0 0 auto;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;
        width: calc(100% / 7);
        padding: 2px;
        font-size: 12px;

        &__label {
            display: flex;
            flex: 1 0 auto;
            align-items: center;
            justify-content: center;
            height: 44px;
            background-color: #fbfbfb;
            border: 1px solid transparent;
            text-transform: uppercase;
        }
    }

    &__day--inactive {
        opacity: 0.3;
    }

    &__day--today {
        .ux-iws-event-calendar-sheet__day__label {
            background-color: $color-white;
            border-color: $color-green-100;
            color: $color-black;
            font-weight: 700;
        }
    }

    &__day--highlighted {
        .ux-iws-event-calendar-sheet__day__label {
            background-color: $color-green-100;
            color: $color-white;
        }
    }
}

.ux-iws-event-calendar-sheet--compact {
    @media (max-width: 567px) {
        .ux-iws-event-calendar-sheet__days,
        .ux-iws-event-calendar-sheet__day-names {
            display: none;
        }
    }
}
